// src/utils/numberConversionUtils.ts

/**
 * Converts Farsi numerals in a string to English numerals.
 *
 * @param input - The input string containing Farsi numerals.
 * @returns The string with Farsi numerals converted to English numerals.
 */
export const convertFarsiToEnglishNumerals = (input: string): string => {
    const farsiNumerals: string[] = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
    const englishNumerals: string[] = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];

    let convertedInput = input;
    for (let i = 0; i < farsiNumerals.length; i++) {
        const regex = new RegExp(farsiNumerals[i], 'g');
        convertedInput = convertedInput.replace(regex, englishNumerals[i]);
    }
    return convertedInput;
};
